<template>
  <div>
    {{ $t('components.payments.integrations.stripe.creditDebit') }}
  </div>
</template>

<script>
export default {
}
</script>
